import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-tab-item',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div [hidden]="!active">
      <ng-content></ng-content>
    </div>
  `,
  styles: ``,
})
export class TabItemComponent {
  @Input() active = false;
}
